import KeyValueListDisplay from '@/components/KeyValueDisplay';
import { convertISODateToMMDDYYYY, displayFullName } from '@/lib/utils';
import type { HomeInspectionWorkOrderResponse } from '@/types/homeInspection.types';

type Props = { workOrder: HomeInspectionWorkOrderResponse };

export const HIWorkOrderSidePanelServiceDetails = ({ workOrder }: Props) => {
  const details = [
    { label: 'Mortgage Company / Plaintiff', value: workOrder.mortgageCompanyOrPlaintiff || '-' },
    { label: 'Property Address',             value: workOrder.propertyAddress || '-' },
    { label: 'City',                         value: workOrder.city || '-' },
    { label: 'State',                        value: workOrder.state || '-' },
    { label: 'Zip Code',                     value: workOrder.zipCode || '-' },
    { label: "Owner's Name / Defendant",     value: workOrder.ownerOrDefendantName || '-' },
    {
      label: 'Last Serve Date',
      value: workOrder.lastServeDate ? convertISODateToMMDDYYYY(workOrder.lastServeDate) : '-',
    },
    {
      label: 'Date Assigned',
      value: workOrder.dateAssigned ? convertISODateToMMDDYYYY(workOrder.dateAssigned) : '-',
    },
    {
      label: 'Server',
      value: workOrder.server ? displayFullName(workOrder.server) : '-',
    },
  ];

  return (
    <div className="flex flex-col gap-4 w-full px-6 py-4">
      <div className="flex flex-col gap-2 w-full text-sm">
        <KeyValueListDisplay data={details} />
      </div>
    </div>
  );
};
